<template>
  <el-card class="search-history">
    <h4 class="card-title">{{ $t('searchHistory') }}</h4>
    <div class="card-content" v-if="data && data.length">
      <div class="data-list">
        <span class="search-history-item pointer" v-for="item in data" :key="item" @click="handleSearchItem(item)">{{ item }}</span>
      </div>
      <div class="clear pointer" @click="handleClear">
        <i class="el-icon-delete" style="font-size: 18px; margin-right: 5px"></i>{{ $t('clear') }}
      </div>
    </div>
    <bsp-empty small-empty v-else></bsp-empty>
  </el-card>
</template>

<script>
  export default {
    name: "SearchHistory",
    props: {
      data: {
        type: Array,
        default() {
          return []
        }
      }
    },
    methods: {
      handleClear() {
        // 清空搜索历史
        if (!this.data.length) {
          this.$message.error('您没有搜索记录可以清空');
          return;
        }
        this.$confirm('确定清空您的搜索历史?', '提示', {
          type: 'warning'
        }).then(() => {
          this.$emit('clear');
        }).catch(() => {});
      },
      // 搜索历史点击，代入搜索框
      handleSearchItem(val) {
        this.$emit('search', val);
      }
    }
  }
</script>
